import React from 'react';
import { useParams } from 'react-router-dom';
import { ChevronIcon } from '../../svg';

const BreadCrumbs = ({ faqData, privacyData }) => {
	let { section } = useParams();

	const filteredRouteData = [...faqData, ...privacyData];

	let listItems = filteredRouteData
		.filter((data) => data.slug === section)
		.map((routeData, index) => (
			<div className='d-flex align-items-center' key={index}>
				<ChevronIcon className='mr-10 ml-10' />
				<div className='text-dark-medium'>{routeData.title}</div>
			</div>
		));

	return listItems && listItems;
};

export default BreadCrumbs;
